import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {OrderReadyDisplayData} from "./order-ready-display.data";
import {
    MetaTagDefinitionData,
    MetaTagDefinitionReferenceData,
    MetaTagType
} from "../../catalogue/meta-tag/meta-tag.data";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class OrderReadyDisplayEntityModel extends EntityModel<OrderReadyDisplayData> {

    translateService: TranslateService;

    constructor(injector: Injector) {
        super(injector, OrderReadyDisplayData);
        this.translateService = injector.get(TranslateService, null);
    }

    private async addUnqualifiedQualifier(display: OrderReadyDisplayData): Promise<void> {
        if (display.matchUnqualified) {
            const qualifier: MetaTagDefinitionReferenceData = EntityData.create(MetaTagDefinitionReferenceData);
            qualifier.metaTagDefinitionId = MetaTagDefinitionData.MATCH_UNTAGGED_ITEM;
            qualifier.name = await this.translateService.get("wbo.meta-tag.option.modifier.unqualified").toPromise();
            qualifier.type = MetaTagType.DOCKET_SELECTOR;
            display.orderReadyQualifiers.unshift(qualifier);
            display.matchUnqualified = false;
        }
    }

    private removeUnqualifiedQualifier(display: OrderReadyDisplayData): void {
        display.matchUnqualified = !!display.orderReadyQualifiers.find((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId === MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
        display.orderReadyQualifiers = display.orderReadyQualifiers.filter((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId !== MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
    }

    protected override onBeforeSaveEntity(entityData: OrderReadyDisplayData) {
        this.removeUnqualifiedQualifier(this.data);
    }

    protected override onAfterLoadEntity(): void {
        this.addUnqualifiedQualifier(this.data);
    }
}
